document.addEventListener("DOMContentLoaded", (event) => {
  if (window.location.pathname === "/cart") {
    const ltspMessage = document.querySelector(
      ".cart__page .bsscommerce-ltsp-message"
    );
    if (ltspMessage) {
      const removeEles = document.querySelectorAll(
        "[data-subtotal], .cart__checkout-wrapper"
      );
      if (removeEles.length) {
        removeEles.forEach((item) => {
          item.remove();
        });
      }
    }
  }
});
